import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Alert
} from '@customink/pigment-react';

type DesignUnsavedDialogProps = {
  subtitle: string;
  open: boolean;
  onClose: () => void;
  onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDismiss: () => void;
};

export const DesignUnsavedDialog = ({
  subtitle,
  open,
  onClose,
  onSubmit,
  onDismiss
}: DesignUnsavedDialogProps) => {
  return (
    <Dialog open={open} title="Save Design?" onClose={onClose} width="sm">
      <DialogContent sx={{textAlign: 'center'}}>
        <Alert sx={{marginTop: '8px'}} severity="error">
          {subtitle}
        </Alert>
      </DialogContent>
      <DialogActions direction="column">
        <Button fullWidth size="medium" variant="primary" onClick={onSubmit}>
          Save My Design
        </Button>
        <Button fullWidth size="medium" variant="secondary" onClick={onDismiss}>
          Continue Without Saving
        </Button>
      </DialogActions>
    </Dialog>
  );
};
